<template>
  <b-modal
    no-close-on-backdrop
    size="md"
    hide-footer
    id="new_classification"
    title="NOVA CLASSIFICAÇÃO"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox v-model="active" :value="1" :unchecked-value="0">
            Ativo
          </b-checkbox>
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../../lib/ToastNotification";
import api from "../../../services/api";
import WarningRequiredFields from "../../Components/WarningRequiredFields.vue";
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import LabelRequiredField from "../../Components/LabelRequiredField.vue";

export default {
  name: "NewClassification",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      errors: [],
      loading: false,
      name: "",
      active: 1,
    };
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
      this.active = 1;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = { name: this.name, active: this.active };
        const response = await api.post(
          "/rest-home/providers/classification",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_classification");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>